module.exports = __webpack_public_path__ + "static/media/survey_progress.eb925b78.png";